<div class="m2-container-default">
<form [formGroup]="companyDetailsFormGroup">
  <div class="merchant-form-body">
    <div class="field-title mb-4 mt-4">About your company</div>
    <p>
      Before you get started, let's ensure that your company details are
      accurate.
    </p>
    <div class="field-title mb-4">
      Registered company name (same as SEC document)
    </div>
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>Company Name</mat-label>
      <input
        matInput
        placeholder="Company Name"
        formControlName="BusinessName"
      />
    </mat-form-field>

    <div class="field-title mb-4">
      Registered company address (same as SEC document)
    </div>
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>Street</mat-label>
      <input matInput placeholder="Street" formControlName="BusinessAddress" [matAutocomplete]="auto"/>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let address of addresses" [value]="address">
          {{address}}
        </mat-option>
    </mat-autocomplete>
    </mat-form-field>

    <div class="flex flex-row">
      <div class="merchant-column merchant-column-50">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>City</mat-label>
          <input matInput placeholder="City" formControlName="BusinessCity" />
        </mat-form-field>
      </div>
      <div class="merchant-column merchant-column-50">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Zip Code</mat-label>
          <input
            matInput
            placeholder="Zip Code"
            formControlName="BusinessPostalCode"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="merchant-form">
      <div class="field-title mb-4">
        Trading name (what will be published in app)
      </div>
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name" formControlName="TradingName" />
      </mat-form-field>
    </div>

    <div class="flex flex-row">
      <div class="merchant-column merchant-column-50">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Company Phone</mat-label>
          <input
            matInput
            [value]="merchantUser.BusinessPhone"
            matInput
            placeholder="Phone"
            formControlName="BusinessPhone"
          />
        </mat-form-field>
      </div>
      <div class="merchant-column merchant-column-50">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Email</mat-label>
          <input
            matInput
            [value]="merchantUser.BusinessEmail"
            matInput
            placeholder="Email"
            formControlName="BusinessEmail"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="flex flex-row review-detail-message">
      <img
        src="/XpressApp/assets//images/small-icons/ExclamationCircleFilled.svg"
        alt=""
      />
      <div class="field-title">
        Please review the information on the above to make sure the details are
        correct
      </div>
    </div>

    <div class="merchant-form mt-4">
      <div
        class="flex flex-row"
        style="
          display: flex;
          flex-direction: row-reverse;
          flex-wrap: nowrap;
          justify-content: flex-end;
        "
      >
        <button
          *ngIf="disabled"
          mat-flat-button
          color="basic"
          class="edit-button-flat-background font-size-default"
          (click)="onEditInput()"
        >
          Edit
        </button>
        <button
          *ngIf="!disabled"
          mat-flat-button
          color="basic"
          class="edit-button-flat-background"
          (click)="onCancel()"
        >
          Cancel
        </button>
        <button
          *ngIf="!disabled"
          class="ml-4"
          mat-flat-button
          color="primary"
          (click)="onEditSave()"
          [disabled]="!isChanged || !companyDetailsFormGroup.valid"
        >
          Save
        </button>

        <button
          *ngIf="!isEditing"
          mat-flat-button
          color="primary"
          class="ml-4 font-size-default"
          (click)="onConfirmDetails()"
        >
          The Details are correct
        </button>
      </div>
      <mat-progress-bar mode="indeterminate" *ngIf="onSaving">
      </mat-progress-bar>
    </div>
  </div>
</form>
</div>
